export const getServiceUrl = () => {
  const { protocol, hostname } = window.location;

  if (hostname === "localhost") {
    return `${protocol}//${hostname}:8000`;
  }

  return `${protocol}//${hostname}`;
};

export const SERVICE_URL = getServiceUrl();

export const getSignInUrl = ({ locale = "ko", redirectUrl }: { locale?: string; redirectUrl?: string }) => {
  const { protocol, hostname } = window.location;

  // 로컬 개발 서버 (fe 레포를 3001번 포트로 실행할 시)
  if (hostname === "localhost") {
    return `${protocol}//${hostname}:3001/${locale}/account/sign-in${redirectUrl ? `?redirect=${redirectUrl}` : ""}`;
  }

  // PR 서버
  if (hostname.endsWith(".dev.bb-int.net")) {
    return `https://buildblock-fe.test.bb-int.net//${locale}/account/sign-in${redirectUrl ? `?redirect=${redirectUrl}` : ""}`;
  }

  // 테스트 서버 (테스트 서버 인터널 주소)
  if (hostname.endsWith(".test.bb-int.net")) {
    return `https://buildblock-fe.test.bb-int.net//${locale}/account/sign-in${redirectUrl ? `?redirect=${redirectUrl}` : ""}`;
  }

  // 테스트 서버
  if (hostname.endsWith(".test.buildblock.ai")) {
    return `https://test.buildblock.ai//${locale}/account/sign-in${redirectUrl ? `?redirect=${redirectUrl}` : ""}`;
  }

  // 운영 서버 (운영 서버 인터널 주소)
  if (hostname.endsWith(".prod.bb-int.net")) {
    return `https://buildblock-fe.prod.bb-int.net//${locale}/account/sign-in${redirectUrl ? `?redirect=${redirectUrl}` : ""}`;
  }

  // 운영 서버
  return `https://buildblock.ai/${locale}/account/sign-in${redirectUrl ? `?redirect=${redirectUrl}` : ""}`;
};
